/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const inventorySuppliers = sqliteTable('inventory_suppliers', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  supplier_name: text('supplier_name'),
  contact_person: text('contact_person'),
  phone: text('phone'),
  email: text('email'),
  address: text('address'),
  tax_id: text('tax_id'),
  payment_terms: text('payment_terms'),
  notes: text('notes'),
  status: text('status'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
